import { Icon } from '../components/Icon';
import { TabBar } from '../components/ui';

export function Habits() {
  return (
    <div className="flex flex-col h-full safe-top">
      <div className="px-5 pt-6">
        <h1 className="font-display text-[34px] leading-none">Habits</h1>
        <p className="text-[13px] text-ink-500 mt-1">Read a little, every day.</p>
      </div>

      <div className="px-5 mt-6">
        <div className="rounded-3xl p-5 bg-gradient-to-br from-forest-500 to-forest-600 text-cream-50 shadow-card">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="flame" className="w-4 h-4 text-coral" />
            <span className="text-[11px] uppercase tracking-[.15em] opacity-80">Reading streak</span>
          </div>
          <div className="flex items-baseline gap-1">
            <span className="font-display text-[64px] leading-none">0</span>
            <span className="text-[14px] opacity-70">days</span>
          </div>
          <div className="mt-4 grid grid-cols-7 gap-1.5">
            {Array.from({ length: 28 }).map((_, i) => (
              <div key={i} className="aspect-square rounded-md bg-cream-50/15" />
            ))}
          </div>
          <p className="text-[12px] opacity-70 mt-3">Read for 5 minutes today to start.</p>
        </div>
      </div>

      <div className="px-5 mt-6">
        <div className="rounded-2xl p-4 bg-paper dark:bg-night-800 shadow-soft">
          <div className="text-[11px] uppercase tracking-[.2em] text-ink-500">Daily goal</div>
          <div className="flex items-baseline gap-1 mt-1">
            <span className="font-display text-[28px]">0</span>
            <span className="text-[13px] text-ink-500">/ 10 pages today</span>
          </div>
        </div>
      </div>

      <div className="flex-1" />
      <TabBar active="habits" />
    </div>
  );
}
